import { atarrayaApi } from '../../api-common'

export const state = {
  devices: [],
  configurations:[]
}

export const getters = {
  devices: (state) => state.devices,
  configurations: (state) => state.configurations
}

export const mutations = {
  LOAD_DEVICES(state, data) {
    state.devices = data
  },

  ADD_DEVICE(state, data) {
    state.devices.push(data)
  },

  UPDATE_DEVICE(state, data) {
    const index = state.devices.findIndex((f) => f.id === data.id)
    if (index >= 0) {
      for (const attr in data) {
        if (Object.hasOwnProperty.call(state.devices[index], attr)) {
          state.devices[index][attr] = data[attr]
        }
      }
    }
  },

  DELETE_DEVICE(state, item) {
    state.devices.splice(state.devices.indexOf(item), 1)
  },

  LOAD_CONFIGURATIONS(state, data) {
    state.configurations = data
  },

  ADD_CONFIGURATION(state, data) {
    state.configurations.push(data)
  },

  UPDATE_CONFIGURATION(state, data) {
    state.configurations.push(data)
  },
}

export const actions = {
  async getDevices({ commit }) {
    const response = await atarrayaApi.get('/device')
    commit('LOAD_DEVICES', response.data.data)
    return response.data.data
  },

  async getDevicesByFarm ({ commit }, farmId) {
    const response = await atarrayaApi.get(`/device/bluewhale/${farmId}`)
    commit('LOAD_DEVICES', response.data.data)
    return response.data.data
  },

  async addDevice({ commit }, data) {
    const response = await atarrayaApi.post('/device', data)
    commit('ADD_DEVICE', response.data.data)
  },

  async editDevice({ commit }, data) {
    await atarrayaApi.put(`/device/${data.id}`, data)
    commit('UPDATE_DEVICE', data)
  },

  async deleteDevice({ commit }, item) {
    await atarrayaApi.delete(`/device/${item.id}`)
    commit('DELETE_DEVICE', item)
  },

  async getConfigurations({ commit }) {
    const response = await atarrayaApi.get('/configuration')
    commit('LOAD_CONFIGURATIONS', response.data.data)
    return response.data.data
  },

  async addConfiguration({ commit }, data) {
    const response = await atarrayaApi.post('/configuration', data)
    commit('ADD_CONFIGURATION', response.data.data)
  },

  async updateConfiguration({ commit }, data) {
    const response = await atarrayaApi.patch(`/configuration/${data.id}`, data)
    commit('UPDATE_CONFIGURATION', response.data.data)
  },
}
